import { MessageType, MessageMsgType, MessageMsgFrom, MessagesSet, QuestionEntity } from '@tencent/dz-models';
import { RecommendType } from '../const';

const getCardType = (type: RecommendType): MessageType => {
  let messageType = 0;
  switch (type) {
    case RecommendType.Hospital:
      messageType = MessageType.HospitalCard;
      break;
    case RecommendType.Doctor:
      messageType = MessageType.DoctorCard;
      break;
    case RecommendType.Disease:
      messageType = MessageType.DiseaseCard;
      break;
    case RecommendType.Activity:
      messageType = MessageType.ActivityCard;
      break;
    default:
      break;
  }
  return messageType;
};

export const formatCards = (cardList: any[] = []) => {
  let minDoctorIndex = Infinity;

  const { doctorList, newCardList } = cardList.reduce((pre, cur) => {
    if (cur.type === RecommendType.Doctor) {
      pre.doctorList.push({
        ...cur.content,
        recommendMode: cur.recommendMode,
        nerMode: cur.nerMode,
      });
      if (cur.serialNo < minDoctorIndex) {
        minDoctorIndex = cur.serialNo;
      }
    } else {
      pre.newCardList.push(cur);
    }
    return pre;
  }, { doctorList: [], newCardList: [] });

  // 合并医生卡片，合并到最小序列号位置
  if (doctorList.length !== 0) {
    newCardList.push({
      serialNo: minDoctorIndex,
      type: 2,
      content: doctorList,
    });
  }

  const nextList = newCardList.sort((a: any, b: any) => a.serialNo - b.serialNo);
  const messageList: MessagesSet[] = nextList.reduce((pre: any, card: any) => {
    const cardType = getCardType(card.type);
    if (cardType) {
      pre.push({
        type: cardType,
        msg_type: MessageMsgType.System,
        payload: card,
        msg_from: MessageMsgFrom.Server,
      });
    }
    return pre;
  }, []);

  return {
    list: nextList,
    messageList,
  };
};

export const formatQuestions = (questionList: any[] = []) => {
  const list: QuestionEntity[] = questionList
    .sort((a, b) => a.seriaNo - b.seriaNo)
    .map(item => ({ question: item.question }));

  const messageList: MessagesSet = {
    type: MessageType.QuestionRecommen,
    msg_type: MessageMsgType.Rich,
    msg_from: MessageMsgFrom.Server,
    payload: { message: list },
  };
  return {
    list,
    messageList,
  };
};
